import { createReducer, on } from '@ngrx/store';
import { Category } from '@models/category.model';
import {
  cannotCreateCategory,
  cannotDeleteCategory,
  cannotFetchCategories,
  cannotUpdateCategory,
  categoriesFetched,
  categoryCreated,
  categoryDeleted,
  categoryUpdated,
  createCategory,
  deleteCategory,
  fetchCategories,
  setCategoryDetail,
  updateCategory,
} from '../actions/category.actions';
import { SharedState } from './index';

export interface CategoryState extends SharedState {
  categories: Category[];
  selectedCategory?: string;
}

export const initialCategoryState: CategoryState = {
  loaded: false,
  isLoading: false,
  error: '',
  categories: [],
  selectedCategory: undefined
}

export const categoryReducer = createReducer(
  initialCategoryState,
  on(fetchCategories, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(categoriesFetched, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    categories: payload
  })),
  on(cannotFetchCategories, (state, {error}) => ({...state, isLoading: false, loaded: false, error, categories: []})),
  on(updateCategory, createCategory, deleteCategory, (state) => ({
    ...state,
    isLoading: true,
    error: '',
    loaded: false
  })),
  on(categoryUpdated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    categories: state.categories.map(c => c.id === payload.id ? payload : c)
  })),
  on(categoryCreated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    categories: [...state.categories, payload]
  })),
  on(setCategoryDetail, (state, {payload}) => ({
    ...state,
    selectedCategory: payload
  })),
  on(categoryDeleted, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    categories: state.categories.filter(c => c.id !== payload)
  })),
  on(cannotUpdateCategory, cannotCreateCategory, cannotDeleteCategory, (state, {error}) => ({
    ...state,
    isLoading: false,
    loaded: false,
    error
  })),
);
